import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'

import '@/styles/index.scss' // global css
import App from './App'
import store from './store'
import router from './router'

import i18n from './lang' // internationalization
import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log

import * as filters from './filters' // global filters
import permission from './directive/permission/index.js'// v-show指令权限
Vue.use(permission)
import checkPermission from './utils/permission' // v-if指令权限
Vue.use(checkPermission)
import { parseTime, getTreeDeepArrcode, validateaccount } from './utils/index.js' // 转时间方法
Vue.prototype.$parseTime = parseTime
Vue.prototype.$validateaccount = validateaccount
Vue.prototype.$getTreeDeepArrcode = getTreeDeepArrcode
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
import '../node_modules/echarts/map/js/province/anhui.js' // 引入北京地图数据
import '../node_modules/echarts/map/js/province/aomen.js' // 引入福建地图数据
import '../node_modules/echarts/map/js/province/beijing.js' // 引入安徽地图数据
import '../node_modules/echarts/map/js/province/chongqing.js' // 引入新疆地图数据
import '../node_modules/echarts/map/js/province/fujian.js' // 引入西藏地图数据
import '../node_modules/echarts/map/js/province/gansu.js' // 引入北京地图数据
import '../node_modules/echarts/map/js/province/guangdong.js' // 引入福建地图数据
import '../node_modules/echarts/map/js/province/guangxi.js' // 引入安徽地图数据
import '../node_modules/echarts/map/js/province/guizhou.js' // 引入新疆地图数据
import '../node_modules/echarts/map/js/province/hainan.js' // 引入西藏地图数据
import '../node_modules/echarts/map/js/province/hebei.js' // 引入北京地图数据
import '../node_modules/echarts/map/js/province/heilongjiang.js' // 引入福建地图数据
import '../node_modules/echarts/map/js/province/henan.js' // 引入安徽地图数据
import '../node_modules/echarts/map/js/province/hubei.js' // 引入新疆地图数据
import '../node_modules/echarts/map/js/province/hunan.js' // 引入西藏地图数据
import '../node_modules/echarts/map/js/province/jiangsu.js' // 引入北京地图数据
import '../node_modules/echarts/map/js/province/jiangxi.js' // 引入福建地图数据
import '../node_modules/echarts/map/js/province/jilin.js' // 引入安徽地图数据
import '../node_modules/echarts/map/js/province/liaoning.js' // 引入新疆地图数据
import '../node_modules/echarts/map/js/province/neimenggu.js' // 引入西藏地图数据
import '../node_modules/echarts/map/js/province/ningxia.js' // 引入安徽地图数据
import '../node_modules/echarts/map/js/province/qinghai.js' // 引入新疆地图数据
import '../node_modules/echarts/map/js/province/shandong.js' // 引入西藏地图数据
import '../node_modules/echarts/map/js/province/shanghai.js' // 引入北京地图数据
import '../node_modules/echarts/map/js/province/shanxi.js' // 引入福建地图数
import '../node_modules/echarts/map/js/province/shanxi1.js' // 引入安徽地图数据
import '../node_modules/echarts/map/js/province/sichuan.js' // 引入新疆地图数据
import '../node_modules/echarts/map/js/province/taiwan.js' // 引入西藏地图数据
import '../node_modules/echarts/map/js/province/tianjin.js' // 引入新疆地图数据
import '../node_modules/echarts/map/js/province/xianggang.js' // 引入西藏地图数据
import '../node_modules/echarts/map/js/province/xinjiang.js' // 引入北京地图数据
import '../node_modules/echarts/map/js/province/xizang.js' // 引入福建地图数据
import '../node_modules/echarts/map/js/province/yunnan.js' // 引入安徽地图数据
import '../node_modules/echarts/map/js/province/zhejiang.js' // 引入新疆地图数据
/**
 * If you don't want to use mock-server如果不想使用mock-server
 * you want to use MockJs for mock api您希望将MockJs用于模拟api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,目前MockJs将在生产环境中使用，
 * please remove it before going online! ! !
 */
// import * as mock from '../mock'
// if (process.env.NODE_ENV === 'production') {
//   mock.mockXHR()
// }

Vue.use(Element, {
  size: Cookies.get('size') || 'mini', // 设置元素-ui默认大小  原本是medium
  i18n: (key, value) => i18n.t(key, value)
})

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
